import { render, staticRenderFns } from "./SpecialPricingGroups.vue?vue&type=template&id=2974fb9f&scoped=true"
import script from "./SpecialPricingGroups.vue?vue&type=script&lang=js"
export * from "./SpecialPricingGroups.vue?vue&type=script&lang=js"
import style0 from "./SpecialPricingGroups.vue?vue&type=style&index=0&id=2974fb9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974fb9f",
  null
  
)

export default component.exports